import { Medal, ChevronRight } from "lucide-react";
import { Group } from "../../../models/groupedTeams";



export const MobileGroupCard = ({
  group,
  index,
  expandedGroups,
  setExpandedGroups,
  teamData,
  navigate,
}: {
  group: Group;
  index: number;
  expandedGroups: Set<string>;
  setExpandedGroups: (groups: Set<string>) => void;
  teamData: any[];
  navigate: any;
}) => {
  return (
    <div key={group.id} className="space-y-2">
      <div
        className={`leaderboard-card bg-white dark:bg-gray-800 rounded-lg shadow p-4 cursor-pointer transition-colors duration-200 ${
          expandedGroups.has(group.id) ? "bg-gray-50 dark:bg-gray-700" : ""
        }`}
        onClick={() => {
          const newExpandedGroups = new Set(expandedGroups);
          if (expandedGroups.has(group.id)) {
            newExpandedGroups.delete(group.id);
          } else {
            newExpandedGroups.add(group.id);
          }
          setExpandedGroups(newExpandedGroups);
        }}
      >
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="font-medium text-gray-900 dark:text-white">
              {group.name}
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400">
              {group.teamIds?.length || 0} Teams
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center text-sm text-gray-500 dark:text-gray-400">
          <span>Sno. #{index + 1}</span>
          <ChevronRight
            className={`w-5 h-5 text-green-600 transition-transform ${
              expandedGroups.has(group.id) ? "rotate-90" : ""
            }`}
          />
        </div>
      </div>

      {/* Show teams when group is expanded */}
      {expandedGroups.has(group.id) &&
        (teamData || [])
          .filter((team) => team.groupName === group.name)
          .sort((a, b) => b.totalScore - a.totalScore)
          .map((team, teamIndex) => (
            <div
              key={team.teamId}
              className="ml-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg shadow p-4 cursor-pointer"
              onClick={() => {
                const currentPath = window.location.pathname;
                if (currentPath.startsWith("/currentSeason")) {
                  navigate(`/currentSeason/leaderboard/team/${team.teamId}`);
                } else {
                  navigate(`/leaderboard/team/${team.teamId}`);
                }
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  {teamIndex < 2 && (
                    <Medal
                      className={`w-4 h-4 ${
                        teamIndex === 0 ? "text-yellow-400" : "text-gray-400"
                      }`}
                    />
                  )}
                  {team.teamLogo && (
                    <img
                      src={`/api/static/images/${team.teamLogo}`}
                      alt={team.teamName}
                      className="w-8 h-8 rounded-full"
                    />
                  )}
                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                    {team.teamName}
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="text-sm font-medium text-gray-900 dark:text-white mr-2">
                    {team.totalScore}
                  </span>
                  <ChevronRight className="w-4 h-4 text-gray-400" />
                </div>
              </div>
            </div>
          ))}
    </div>
  );
};
